import { Flex, Text, useMatchBreakpointsContext } from '@pancakeswap/uikit'
import useBounce from 'views/Page/useBounce'
import { IoIosArrowUp } from '@react-icons/all-files/io/IoIosArrowUp'
import { animated } from 'react-spring'
import { Link } from 'react-scroll'
import { SocialLink, StyledSocialIcon } from './styled'
import styles from '../Swiper/styles.module.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SwiperFlex, SwiperText } from '../Swiper/styled'
import 'swiper/css'
import 'swiper/css/effect-cards'
import { EffectCoverflow, EffectCards, Navigation, Pagination } from 'swiper/modules'
import SocialSlide from './SocialSlide'

const Social = () => {
  const { isDesktop } = useMatchBreakpointsContext()
  const { style, startBounce, stopBounce } = useBounce()

  return (
    <>
      <Flex
        flexDirection="column"
        width="100%"
        id="target-social"
        height="100%"
        justifyContent="space-between"
        alignItems="center"
        minHeight="100vh"
      >
        <Flex />
        <Swiper
          loop={true}
          effect={'cards'}
          navigation={true}
          grabCursor={true}
          modules={[EffectCards, Navigation]}
          className={styles.swiper}
        >
          <SwiperSlide className={`${styles.baseslide} ${styles.socials}`}>
            <Flex width="100%" height="100%">
              <Flex flex={2} />

              <SwiperFlex width="100%" height="100%" flex={3}>
                <Flex justifyContent="flex-start" alignItems="center" flexDirection="column" mt="2rem">
                  <Text textAlign="center" letterSpacing="1px" fontSize="2rem" color="#ccc" fontWeight="700">
                    CONNECT
                  </Text>
                  <SwiperText fontSize="2.5rem" fontWeight="600" textAlign="center">
                    {' '}
                    WITH US{' '}
                  </SwiperText>
                </Flex>

                <Flex width="100%" justifyContent="space-between">
                  <SocialLink passHref href="https://www.reddit.com/r/BaseswapFi/?rdt=53384">
                    <StyledSocialIcon style={{ width: '80px', height: '80px' }} url="reddit.com" fgColor="#fff" />
                  </SocialLink>
                  <SocialLink passHref href="https://discord.com/invite/baseswap">
                    <StyledSocialIcon style={{ width: '80px', height: '80px' }} url="discord.com" fgColor="#fff" />
                  </SocialLink>
                  <SocialLink passHref href="https://twitter.com/BaseSwapDex">
                    <StyledSocialIcon style={{ width: '80px', height: '80px' }} url="x.com" fgColor="#fff" />
                  </SocialLink>
                </Flex>

                <Flex width="100%" justifyContent="space-between">
                  <SocialLink passHref href="https://t.me/BaseswapFi">
                    <StyledSocialIcon style={{ width: '80px', height: '80px' }} url="telegram.com" fgColor="#fff" />
                  </SocialLink>
                  <SocialLink passHref href="https://github.com/baseswapfi">
                    <StyledSocialIcon style={{ width: '80px', height: '80px' }} url="github.com" fgColor="#fff" />
                  </SocialLink>
                  <SocialLink passHref href="https://medium.com/@BaseSwap">
                    <StyledSocialIcon style={{ width: '80px', height: '80px' }} url="medium.com" fgColor="#fff" />
                  </SocialLink>
                </Flex>
              </SwiperFlex>

              <Flex flex={2} />
            </Flex>
          </SwiperSlide>
        </Swiper>

        <Flex
          flexDirection="column"
          justifyContent="flex-end"
          alignItems="center"
          mt="0rem"
          style={{ cursor: 'pointer' }}
        >
          <Link to="target-hero" smooth={true} duration={500} onMouseEnter={startBounce} onMouseLeave={stopBounce}>
            <Flex justifyContent="center" alignItems="center">
              <animated.div style={style}>
                <IoIosArrowUp size="50px" color="#ccc" />
              </animated.div>
            </Flex>
            <Text fontSize="24px" fontWeight="600" color="#ccc">
              TO TOP
            </Text>
          </Link>
        </Flex>
      </Flex>
    </>
  )
}

export default Social
